/* ==========================================================================
   SearcherPackagesFerry > Select
   ========================================================================== */

/* Modules */
const SelectClient = require('@bluekiri/alexandria-contrib-components/components/select/client/js');
const config = require('./config');
const transactions = require('./transactions');
const calendar = require('./calendar');

const groupLiterals = [];

let storedPorts = {};

/* Init  */
function initSelect(selector, instance) {
    /* Instance references */
    const result = [];

    instance.element.querySelectorAll('[data-component="Select"]').forEach((item, index) => {
        /* Push autocomplete */
        result.push(
            SelectClient(`${selector} [data-component="Select"][data-type="${config().type.select}-${index}"]`, {
                enableClick: true,
                choices: {
                    addItemText: '',
                    searchPlaceholderValue: instance.element.dataset.searcherports
                },
                onChange: [
                    function fn(e) {
                        if (e.element.getAttribute('data-type') === 'select-0') {
                            if (retrieveCachedPorts(instance) === undefined) {
                                transactions.getPorts(instance, storeCachedPorts);
                            } else {
                                refreshPorts(instance);
                            }
                            if (instance.location[1].value !== undefined && instance.location[1].value !== 0) {
                                calendar.getRouteData(instance);
                            }
                        } else if (e.element.getAttribute('data-type') === 'select-1') {
                            if (instance.location[0].value !== undefined && instance.location[0].value !== 0) {
                                calendar.getRouteData(instance);
                                showVehicleMessageByDestination(instance);
                            }
                        }
                        return false;
                    }
                ]
            })
        );
    });
    instance.element.addEventListener('loadPorts', e => {
        refreshPorts(e.detail.instance);
    });
    pushPortGroupLiterals(instance);
    return result;
}

function storeCachedPorts(rs, instance) {
    storedPorts[getOriginPort(instance.location)] = rs;
    const event = CustomEvent('loadPorts', {
        detail: {
            instance
        }
    });
    instance.element.dispatchEvent(event);
}

function retrieveCachedPorts(instance) {
    return storedPorts[getOriginPort(instance.location)];
}

function pushPortGroupLiterals(instance) {
    groupLiterals.push(instance.element.dataset.frequentports);
    groupLiterals.push(instance.element.dataset.otherports);
}

function getOriginPort(locations) {
    return `${locations[0].value}`;
}

function setStoredPorts(data) {
    storedPorts = data;
}

function refreshPorts(instance) {
    const ports = retrieveCachedPorts(instance);
    const newDestinationPorts = [];

    if (ports !== undefined && ports.groups !== undefined && ports.groups.length > 0) {
        processGroups(newDestinationPorts, ports.groups);
    } else {
        const { starredDestinations, ordinaryDestinations } = buildStarredAndOrdinaryDestionations(instance, ports);

        const headings = [groupLiterals[0], groupLiterals[1]];
        newDestinationPorts.push(buildOptionWithChoices(1, headings[0], starredDestinations));
        newDestinationPorts.push(buildOptionWithChoices(2, headings[1], ordinaryDestinations));
    }

    instance.location[1].setChoices(newDestinationPorts, 'value', 'label', true);

    refreshPortsHandleDestination(instance);
}

function buildStarredAndOrdinaryDestionations(instance, ports) {
    const starredDestinations = [];
    const ordinaryDestinations = [];

    if (ports !== undefined && ports.locations !== null) {
        for (let i = 0; i < ports.locations.length; i++) {
            const port = ports.locations[i];
            const destination = instance.config.endpoint
                ? {
                      value: `${port.value},${port.destinationType},${port.destinationCode}`,
                      label: port.label
                  }
                : port;
            if (port.highlight) {
                starredDestinations.push(destination);
            } else {
                ordinaryDestinations.push(destination);
            }
        }
    }

    return { starredDestinations, ordinaryDestinations };
}

function refreshPortsHandleDestination(instance) {
    if (!instance.location || !instance.location[1] || instance.location[1].value === 0) {
        return;
    }

    const firstDestinationItem = instance.location[1].element.getElementsByClassName('choices__item')[1];

    if (instance.config.endpoint) {
        let newValue = firstDestinationItem.getAttribute('data-value');

        const valuesInDestination = [...instance.location[1].element.getElementsByClassName('choices__item')].map(
            m => m.dataset.value
        );

        if (instance.location[1] && instance.location[1].data) {
            const currValue = instance.location[1].value;

            instance.location[1].data.forEach(group => {
                if (!group || !group.choices || !group.choices.length) return;

                const currentValue = group.choices.filter(item => item.value.includes(currValue));

                if (currentValue.length > 0) {
                    newValue = currentValue[0].value;
                }
            });
        }

        if (valuesInDestination.filter(x => x === instance.location[1].value).length < 2) {
            instance.location[1].set(newValue);
        }
    } else {
        const newValue = parseInt(firstDestinationItem.getAttribute('data-value'), 10);
        const valuesInDestination = [...instance.location[1].element.getElementsByClassName('choices__item')].map(m =>
            parseInt(m.dataset.value, 10)
        );

        if (valuesInDestination.filter(x => x === instance.location[1].value).length < 2) {
            instance.location[1].set(newValue);
        }
    }
}

function buildOptionWithChoices(code, label, choices) {
    return {
        label,
        id: code,
        disabled: false,
        choices
    };
}

function processGroups(newDestinationPorts, groups) {
    groups.forEach(group => {
        const destinations = [];
        if (!group || !group.items) {
            return;
        }
        group.items.forEach(destination => {
            if (!destination) {
                return;
            }
            destinations.push({
                value:
                    `${destination.value},` +
                    `${destination.destinationType},` +
                    `${destination.destinationCode},` +
                    `${destination.withCar}`,
                label: destination.label
            });
        });
        const { title } = group;
        newDestinationPorts.push(buildOptionWithChoices(title, title, destinations));
    });
}

function showVehicleMessageByDestination(instance) {
    if (instance !== undefined && instance.location[1] !== undefined && instance.vehicle !== undefined) {
        const ports = retrieveCachedPorts(instance);
        if (ports !== undefined && ports.locations !== undefined) {
            const destination = ports.locations.find(obj => obj.label === instance.location[1].getSelect().textContent);
            if (destination !== undefined && destination.withCar) {
                instance.vehicle.panel.uipanel.display();
            }
        }
    }
}

module.exports = {
    initSelect,
    refreshPorts,
    setStoredPorts,
    showVehicleMessageByDestination,
    storeCachedPorts
};
